module.exports = __webpack_public_path__ + "img/presets_white.4d6806cc.png";